import * as React from 'react'
import {useFormContext} from 'react-hook-form'
import {useTranslation} from 'react-i18next'
import {makeStyles} from '@material-ui/core/styles'
import {
  useBoldInputStyle,
  useOutlinedInputStyles,
} from 'components/common/useBoldInputStyle'
import RegisterStyle from 'pages/BusinessManagement/MemberRegistration/Style'
import {MenuItem, OutlinedInput, Select} from '@material-ui/core'
import {Agency} from 'api/orgApi'

const useStyles = makeStyles(RegisterStyle)

interface AgencyInputProps {
  listAgency: Agency[]
  agencyId?: number | null
}

export default function AgencyInput(props: AgencyInputProps) {
  const {listAgency, agencyId} = props
  const createMemberInfo = useFormContext()
  const inputClasses = useBoldInputStyle()
  const classes = useStyles()
  const {t} = useTranslation()
  const {
    watch,
    setValue,
    formState: {errors},
  } = useFormContext()
  const outlinedInputClasses = useOutlinedInputStyles()

  React.useEffect(() => {
    if (agencyId !== undefined) {
      setValue('agencyId', agencyId)
    }
  }, [agencyId, setValue])

  const selectedAgencyId = watch('agencyId') ?? -1

  return (
    <div>
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          alignContent: 'center',
          marginTop: 5,
          marginBottom: 5,
        }}
      >
        <p className={inputClasses.inputLabel}>{t('IAffiliatedAgency')}</p>
        <p className={inputClasses.require}>*</p>
      </div>
      <Select
        variant='outlined'
        displayEmpty
        value={selectedAgencyId}
        input={
          <OutlinedInput
            name='agencyId'
            id='outlined-agency-simple'
            classes={outlinedInputClasses}
          />
        }
        className={classes.selectContainer}
        {...createMemberInfo.register('agencyId', {
          setValueAs: (value) => Number(value),
        })}
      >
        <MenuItem value={-1} disabled>
          - {t('IAgency')} -
        </MenuItem>
        {listAgency.map((item) => (
          <MenuItem key={item.id} value={item.id}>
            {item.name} ({item.email})
          </MenuItem>
        ))}
      </Select>
      {errors.agencyId && (
        <span className={inputClasses.errorText}>{t('IRequired')}</span>
      )}
    </div>
  )
}
